<!-- <ng-content /> -->
<div class="sidebar-nav">
    <div class="nav-item">
        <div class="nav-link" (click)="logoutClicked()">
            <div class="nav-icon"><fa-icon [icon]="['fas', 'sign-out-alt']"></fa-icon></div>
            Logout
        </div>
    </div>
</div>
